module.exports = __webpack_public_path__ + "static/VA-aad3a40521e55b9ef22640b0c3185d4d.svg";